import axios, { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import { requestHelpers } from 'helpers';
import { userServices } from 'services';

const getOnlyData = (response: any) => {
  try {
    return response.data;
  } catch (e) {
    return null;
  }
};

const catalogClient = axios.create({
  baseURL: '',
});

const pos365Client = axios.create({
  baseURL: window.REACT_APP_POS_365_SERVICE_API_URL,
});

const getIpAddress = async () => {
  const res = await axios
    .get(window.GET_IP_ADDRESS_URL)
    .catch(() => ({ data: { ip: '' } }));
  return res.data.ip;
};

const getAuthorization = () =>
  userServices.isLoggedIn() ? `Bearer ${userServices.getAccessToken()}` : '';

// Do something before request is sent
const requestInterceptor = async (request: AxiosRequestConfig) => {
  request.headers.Authorization = getAuthorization();
  request.headers['App-Order-Allowed-Ip-Address'] = await getIpAddress();
  return request;
};

// Any status code that lie within the range of 2xx cause this function to trigger
const responseSuccessInterceptor = (response: AxiosResponse) => {
  // Do something with response data
  return response;
};

// Any status codes that falls outside the range of 2xx cause this function to trigger
const responseErrorInterceptor = (error: AxiosError) => {
  // Do something with response error
  requestHelpers.handleResponseError(error);
  return Promise.reject(error);
};

const clients = [pos365Client];

clients.forEach(client => {
  client.interceptors.request.use(requestInterceptor);
  client.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );
});

export default {
  catalogClient,
  pos365Client,
  getOnlyData,
};
